import { Grid, IconButton, Tooltip } from '@mui/material'
import { useCallback, useContext, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import { GlobalContext } from '../../../App'
import Programa from '../../../components/Programa/Programa'
import Edicao from './Edicao'
import PrimeTable from '../../../components/PrimeTable'
import { metodoPrograma } from '../../../components/api'

export const listaSituacao = [
  ['R', 'Receita'],
  ['D', 'Despesa'],
]

export const STATUS_MAP = {
  R: { label: 'Receita', color: '#13cf42', background: '#f6fbff' },
  D: {
    label: 'Despesa',
    color: '#f51515',
    background: '#f6fbff',
  },
}

export function StatusChip({ status }) {
  const info = STATUS_MAP[status]

  if (!info) return status

  return (
    <span
      style={{
        display: 'inline-block',
        padding: '4px 10px',
        borderRadius: '12px',
        fontSize: '13px',
        fontWeight: 600,
        width: '100%',
        color: info.color,
        backgroundColor: info.background,
        textAlign: 'center',
      }}
    >
      {info.label}
    </span>
  )
}

const PlanoDeConta = () => {
  const { localAtendimento } = useContext(GlobalContext)

  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)
  const [setDadosItem] = useState(null)
  const [refresh, setRefresh] = useState(0)

  const voltar = () => {
    setTela('lista')
    setDados(undefined)
  }

  const handleClick = (value) => {
    setDados(value)
    setTela('cadastro')
  }

  const exclui = useCallback((dados) => {
    metodoPrograma('exclui', { idPlanoConta: dados[0] }).then((res) => {
      if (res.status) {
        setRefresh((prev) => prev + 1)
      }
    })
  }, [])

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tela])

  return (
    <Programa codigo="CtrlPlanoDeConta" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {localAtendimento && (
              <PrimeTable
                codigo="CtrlPlanoDeConta"
                action="lista"
                rows={10}
                habSearch
                head={[
                  'Empresa',
                  'Código',
                  'Nome',
                  'Tipo',
                  'Inclusão',
                  'Exclusão',
                ]}
                line={(item) => [
                  item[1]?.[1],
                  item[2],
                  item[3],
                  item?.[4] ? <StatusChip status={item[4]} /> : '',
                  item[5],
                  item[6],
                ]}
                collumnsDateHour={[4, 5]}
                parametros={{ idLocalAtendimento: localAtendimento[0] }}
                onRowSelect={handleClick}
                onDelete={{ index: 5, action: exclui }}
                refresh={refresh}
              />
            )}
          </Grid>
        </Grid>
      ) : (
        <Edicao {...{ dados, voltar, setTela, setDadosItem }} />
      )}
    </Programa>
  )
}

export default PlanoDeConta
